module.exports = "<span class='tag'\n    [class.selected]=\"isSelected\"\n    (click)='switch($event)'>{{label}}</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tag-patent-menu/tag-patent-menu.component.html
// module id = 444
// module chunks = 0